module.exports = __webpack_public_path__ + "static/1-69e47dc17b3cf11a9d73a961a5e7f3df.jpg";